import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { YearProvider } from "./context/YearContext";
import { GoogleAuthCallback } from "./components/GoogleAuthCallback";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Rooms from "./pages/Rooms";
import Competitors from "./pages/Competitors";
import RevenueEngine from "./pages/RevenueEngine";
import AIAnalysis from "./pages/AIAnalysis";
import PriceHistory from "./pages/PriceHistory";
import RedfortsIntegration from "./pages/RedfortsIntegration";
import QuickOccupancy from "./pages/QuickOccupancy";
import Alerts from "./pages/Alerts";
import OccupancyCalendar from "./pages/OccupancyCalendar";
import YearlyComparison from "./pages/YearlyComparison";
import LocalEvents from "./pages/LocalEvents";
import MICEContacts from "./pages/MICEContacts";
import ChangeLog from "./pages/ChangeLog";
import Forecast from "./pages/Forecast";
import PickupReport from "./pages/PickupReport";
import TVMode from "./pages/TVMode";
import OscarRules from "./pages/OscarRules";
import Admin from "./pages/Admin";
import PricesLab from "./pages/PricesLab";
import FutureRates from "./pages/FutureRates";
import Layout from "./components/Layout";
import "./App.css";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="spinner w-8 h-8" />
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function AppRouter() {
  // Leer el hash desde useLocation (reactivo) para detectar la vuelta de Google Auth antes del ProtectedRoute
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <GoogleAuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <ProtectedRoute>
            <Layout>
              <Routes>
                <Route path="/" element={<Dashboard />} />
                <Route path="/rooms" element={<Rooms />} />
                <Route path="/competitors" element={<Competitors />} />
                <Route path="/revenue-engine" element={<RevenueEngine />} />
                <Route path="/ai-analysis" element={<AIAnalysis />} />
                <Route path="/price-history" element={<PriceHistory />} />
                <Route path="/redforts" element={<RedfortsIntegration />} />
                <Route path="/quick-occupancy" element={<QuickOccupancy />} />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/calendar" element={<OccupancyCalendar />} />
                <Route path="/comparison" element={<YearlyComparison />} />
                <Route path="/events" element={<LocalEvents />} />
                <Route path="/contacts" element={<MICEContacts />} />
                <Route path="/changelog" element={<ChangeLog />} />
                <Route path="/forecast" element={<Forecast />} />
                <Route path="/pickup" element={<PickupReport />} />
                <Route path="/tv" element={<TVMode />} />
                <Route path="/oscar-rules" element={<OscarRules />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/precios" element={<PricesLab />} />
                <Route path="/tarifas-futuras" element={<FutureRates />} />
              </Routes>
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <YearProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </YearProvider>
    </AuthProvider>
  );
}

export default App;
